import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { ContentFragment } from 'generated/graphql';
import API from 'constants/constants';
import playIcon from 'assets/img/play-button.svg';

import s from './Tile.module.scss';

export interface ITile {
  data: ContentFragment,
  alias: string,
  isBig?: boolean,
  index: number,
}

const Tile = ({
  data, isBig, alias, index,
}: ITile) => (
  <>
    {data && (
    <div className={cx(s.Tile, s.Item,
      (isBig ? s.Big : ''),
      (isBig ? s.BigTile : ''),
      (index === 0 ? s.BigTile : ''),
      (index === 7 ? s.BigTileRow : ''))}
    >
      <Link to={`/${alias}/${data.id}`} className={s.ContentLink}>
        <div className={s.ContentPreview}>
          <div className={s.ContentItemPreviewImageWrap}>
            <div className={s.ContentItemPreviewImageLazy} />
            <div
              className={s.ContentItemPreviewImage}
              style={{ backgroundImage: `url(${API.FREE_PREVIEW}${data.previews?.[0]?.link})` }}
            >
              {(data.type !== 'html' && data.type !== 'sf_section')
                && <img className={s.PlayIcon} src={playIcon} alt="play" />}
            </div>
          </div>
          <div className={s.ContentDescription}>
            <div className={s.ContentDescriptionInner}>
              <div className={s.ContentDescriptionName}>
                <div className={s.ContentDescriptionNameHide}>{data.name}</div>
              </div>
            </div>
            <div className={s.ContentDescriptionInfo}>{data.description}</div>
          </div>
        </div>
      </Link>
    </div>
    )}
  </>

);

Tile.defaultProps = {
  isBig: false,
};

export default Tile;
